import { breakpoints } from '$theme';
import styled from '@emotion/styled';
import { UmbracoImage } from '~/shared/components/Image';
import { StyledAlignContent } from '../../shared/AlignContent/styled';
import { M76ContentPromotionProps } from './types';

type StyledM75Props = {
    mediaAlignment: M76ContentPromotionProps['mediaHorizontalAlignment'];
    backgroundColor: M76ContentPromotionProps['backgroundColor'];
};

export const StyledM75 = styled.div<StyledM75Props>(
    ({ mediaAlignment, backgroundColor, theme }) => ({
        height: 'auto',
        maxHeight: 1200,
        boxSizing: 'border-box',
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: mediaAlignment === 'left' ? 'column' : 'column-reverse',
        gridAutoColumns: mediaAlignment === 'left' ? '1fr 30%' : '30% 1fr',

        [breakpoints.sm]: {
            gridAutoFlow: 'column',
            display: 'grid',
            gridTemplateAreas: mediaAlignment === 'left' ? '"media content"' : '"content media"',
            gap: theme.space['6'],
        },

        [breakpoints.md]: {
            gap: theme.space['9'],
        },

        [`${StyledAlignContent}`]: {
            backgroundColor,
            gridArea: 'content',
            padding: theme.space['4'],

            [breakpoints.xs]: {
                paddingTop: backgroundColor ? theme.space['7'] : theme.space['5'],
                paddingBottom: backgroundColor ? theme.space['7'] : theme.space['5'],
            },

            [breakpoints.md]: {
                padding: theme.space['6'],
            },
        },
    }),
);

export const StyledMobileMedia = styled.div({
    gridArea: 'media',

    [breakpoints.md]: {
        display: 'none',
    },
});

export const StyledDesktopMedia = styled.div({
    gridArea: 'media',

    [breakpoints.custom({ maxWidth: '1024px' })]: {
        display: 'none',
    },
});

export const StyledDesktopImage = styled(UmbracoImage)({
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    maxHeight: '1100px',
    minHeight: '500px',
});

export const StyledMobileImage = styled(UmbracoImage)({
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    maxHeight: '350px',
    minHeight: '200px',
    aspectRatio: '16/9',

    [breakpoints.sm]: {
        maxHeight: '500px',
        aspectRatio: '1',
    },
});
